module.exports = __webpack_public_path__ + "static/youtube-a66b90079e68641a9fd75d08b615662d.png";